/**
 * IXstone Cart Drawer - Slide-in cart with ATC intercept
 * Intercepts product form submits, fetches /cart/add.js, opens drawer
 */
(function () {
  "use strict";

  var drawer = document.getElementById("cart-drawer");
  var overlay = document.getElementById("cart-drawer-overlay");
  var closeBtn = document.getElementById("cart-drawer-close");
  if (!drawer || !overlay) return;

  var isOpen = false;
  var lastFocused = null;

  // ── Open / Close ──────────────────────────────
  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocused = document.activeElement;
    drawer.classList.add("is-open");
    overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    document.body.style.overflow = "";
    if (lastFocused) lastFocused.focus();
  }

  if (closeBtn) closeBtn.addEventListener("click", close);
  overlay.addEventListener("click", close);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isOpen) close();
    // Focus trap: Tab cycles within drawer
    if (e.key === "Tab" && isOpen) {
      var focusable = drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  });

  // ── Refresh Drawer Contents ────────────────────
  function refreshDrawer() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart.js" : "/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Update count in header
        var headerCount = document.querySelector(".header__cart-count");
        if (headerCount) {
          headerCount.textContent = cart.item_count;
          headerCount.style.display = cart.item_count > 0 ? "" : "none";
        }

        var drawerCount = document.getElementById("cart-drawer-count");
        if (drawerCount) drawerCount.textContent = cart.item_count;

        var subtotal = document.getElementById("cart-drawer-subtotal");
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

        // Re-render items (simple approach: reload section)
        var itemsEl = document.getElementById("cart-drawer-items");
        var emptyEl = document.getElementById("cart-drawer-empty");
        var footerEl = drawer.querySelector(".cart-drawer__footer");

        if (cart.item_count === 0) {
          if (itemsEl) itemsEl.innerHTML = "";
          if (emptyEl) emptyEl.style.display = "";
          if (footerEl) footerEl.style.display = "none";
        } else {
          if (emptyEl) emptyEl.style.display = "none";
          if (footerEl) footerEl.style.display = "";
          // Rebuild items HTML
          if (itemsEl) {
            var html = "";
            cart.items.forEach(function (item) {
              var imgSrc = item.featured_image ? item.featured_image.url.replace(/(\.\w+)$/, "_160x$1") : "";
              html += '<div class="cart-drawer__item" role="listitem" data-key="' + item.key + '">';
              html += imgSrc ? '<img class="cart-drawer__item-img" src="' + imgSrc + '" alt="" width="80" height="80" loading="lazy">' : '<div class="cart-drawer__item-img skeleton--image"></div>';
              html += '<div class="cart-drawer__item-info">';
              html += '<div class="cart-drawer__item-title">' + escHtml(item.product_title) + '</div>';
              html += '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>';
              html += '<div class="qty-stepper" style="margin-top:var(--space-2)">';
              html += '<button class="qty-stepper__btn" type="button" data-action="decrease" data-key="' + item.key + '">−</button>';
              html += '<input class="qty-stepper__input" type="number" value="' + item.quantity + '" min="0" data-key="' + item.key + '">';
              html += '<button class="qty-stepper__btn" type="button" data-action="increase" data-key="' + item.key + '">+</button>';
              html += '</div></div>';
              html += '<button class="cart-drawer__item-remove" type="button" data-key="' + item.key + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg></button>';
              html += '</div>';
            });
            itemsEl.innerHTML = html;
          }
        }
      });
  }

  // ── Intercept ATC Forms ────────────────────────
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.style.opacity = "0.6"; }

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart/add.js", {
      method: "POST",
      body: new FormData(form),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("Add to cart failed");
        return r.json();
      })
      .then(function () {
        refreshDrawer();
        open();
      })
      .catch(function () {
        // Fallback: submit normally
        form.submit();
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.style.opacity = ""; }
      });
  });

  // ── Qty Change & Remove (delegated) ────────────
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-action]");
    if (btn && drawer.contains(btn)) {
      var key = btn.getAttribute("data-key");
      var input = drawer.querySelector('.qty-stepper__input[data-key="' + key + '"]');
      if (!input) return;
      var qty = parseInt(input.value, 10) || 1;
      if (btn.getAttribute("data-action") === "increase") qty++;
      else qty = Math.max(0, qty - 1);
      updateQty(key, qty);
    }

    var removeBtn = e.target.closest(".cart-drawer__item-remove");
    if (removeBtn && drawer.contains(removeBtn)) {
      updateQty(removeBtn.getAttribute("data-key"), 0);
    }
  });

  function updateQty(key, qty) {
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then(function () { refreshDrawer(); });
  }

  // ── Helpers ────────────────────────────────────
  function formatMoney(cents) {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: window.Shopify.currency.active }).format(cents / 100)
      : "€" + (cents / 100).toFixed(2).replace(".", ","));
  }

  function escHtml(s) {
    var d = document.createElement("div");
    d.textContent = s;
    return d.innerHTML;
  }

  // ── Expose for external triggers ──────────────
  window.IXstoneCart = { open: open, close: close, refresh: refreshDrawer };
})();

